import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

const CUSTOM_TEXT_TYPES = new Set([
  'epx:Participant', 'epx:Lane',
  'epx:UserTask', 'epx:ServiceTask', 'epx:ScriptTask', 'epx:ManualTask',
  'epx:SendTask', 'epx:ReceiveTask', 'epx:BusinessRuleTask', 'epx:CallActivity',
  'epx:SubProcess', 'epx:Transaction',
]);

export class GeneralPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  // Returns true for all element types
  isApplicable(_elementType) {
    return true;
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    return [
      {
        id: 'general',
        label: i18n.general || 'General',
        entries: [
          {
            id: 'name',
            component: () => {
              // Shapes that render their own SVG text use properties.name;
              // others use LogicFlow's text overlay (element.text).
              const nameValue = props.name != null ? props.name : (element.text || '');
              return (
                <TextFieldEntry
                  id="epx-name"
                  label={i18n.name || 'Name'}
                  value={nameValue}
                  onChange={(val) => {
                    lf.setProperties(id, { name: val });
                    if (!CUSTOM_TEXT_TYPES.has(element.type)) {
                      lf.updateText(id, val);
                    }
                    lf.emit('node:properties-change', { id, properties: { name: val } });
                  }}
                />
              );
            },
          },
        ],
      },
    ];
  }
}
